import React, {useState} from 'react'
import StoresListFilters from './StoresListFilters'
import {KTIcon, isNotEmpty} from '../../../../../general/helpers'
import {export_stores} from '../../core/_request'
import {useStoresQueryResponse} from '../core/StoresResponseProvider'
import {useIntl} from 'react-intl'
import {useStoresQueryRequest} from '../core/StoresRequestProvider'
import {toast} from 'react-toastify'
import {useAuth} from '../../../auth'
import {PERMISSION_ARRKEY} from '../../../auth/core/constant'
import StoresListCreateButton from './StoresListCreateButton'

const StoresListHeader = () => {
  const [exportLoading, setExportLoading] = useState(false)
  const {query} = useStoresQueryResponse()
  const {state} = useStoresQueryRequest()
  const {getAllowedPermissionValue} = useAuth()
  const intl = useIntl()
  /**
   * starts export stores data
   */
  const triggerStoresExport = async () => {
    const isFiltersEmpty =
      Object.entries(state).find((obj) => {
        return obj[0] !== 'page' && obj[0] !== 'size' && isNotEmpty(obj[1])
      }) === undefined
    if (isFiltersEmpty) {
      toast.error(intl.formatMessage({id: 'FILTER.SELECT'}))
      return
    }
    setExportLoading(true)
    try {
      await export_stores(query)
    } catch (e) {
    } finally {
      setExportLoading(false)
    }
  }
  return (
    <div className='card-header border-0 pt-6'>
      <div className='card-toolbar w-100 d-flex flex-wrap align-items-center'>
        <div className='flex-grow-1 d-flex justify-content-start mb-2 mb-lg-0'>
        {getAllowedPermissionValue(PERMISSION_ARRKEY.CREATE_STORE) && (
          <StoresListCreateButton />
        )}
        </div>
        <div className='d-flex justify-content-end flex-grow-1'>
          <StoresListFilters />
          {getAllowedPermissionValue(PERMISSION_ARRKEY.EXPORT_STORES) && (
            <button
              disabled={exportLoading}
              type='button'
              className='btn btn-light-primary ms-3'
              onClick={triggerStoresExport}
            >
              <KTIcon iconName='exit-up' className='fs-2' />
              {intl.formatMessage({ id: 'EXPORT' })}
              {exportLoading && (
                <span className='spinner-border spinner-border-sm align-middle text-primary ms-2' />
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default StoresListHeader
